import _ from 'lodash';

export const sanitizeTextInput = value => {
	let sanitized = _.trim(`${value || ''}`);

	let start = 0;
	let end = sanitized.length;

	while (start < end && sanitized.charCodeAt(start) === 0x200B) {
		start++;
	}

	while (end > start && sanitized.charCodeAt(end - 1) === 0x200B) {
		end--;
	}

	sanitized = sanitized.slice(start, end);

	return sanitized;
};
